// import { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom"; // 👈 اضافه شد
// import axiosInstance from "../utils/axiosInstance";

// const CATEGORIES = [
//   "بازرگانی",
//   "مالی و حسابداری",
//   "حقوقی و قراردادی",
//   "اداری و مکاتبات",
//   "منابع انسانی",
//   "عملیاتی و پروژه‌ای",
//   "بیمه و مالیات",
//   "فنی و پشتیبانی",
// ];

// const DocumentExplorer = () => {
//   const [activeCategory, setActiveCategory] = useState(CATEGORIES[0]);
//   const [docs, setDocs] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Modal state
//   const [open, setOpen] = useState(false);
//   const [form, setForm] = useState({
//     name: "",
//     description: "",
//     doc_date: "",
//     category: CATEGORIES[0],
//     file: null,
//   });
//   const [submitting, setSubmitting] = useState(false);

//   const navigate = useNavigate();

//   const canSubmit = useMemo(
//     () => form.name.trim() && form.doc_date && form.category && form.file,
//     [form]
//   );

//   // گرفتن لیست اسناد
//   async function fetchDocs(category) {
//     setLoading(true);
//     try {
//       const res = await axiosInstance.get("/documents/upload/file/", {
//         params: { category },
//       });
//       setDocs(res.data.results || []);
//     } catch (e) {
//       console.error("خطا در دریافت اسناد", e);
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     fetchDocs(activeCategory);
//   }, [activeCategory]);

//   function resetForm() {
//     setForm({
//       name: "",
//       description: "",
//       doc_date: "",
//       category: activeCategory ?? CATEGORIES[0],
//       file: null,
//     });
//   }

//   // ارسال سند جدید
//   async function handleSubmit(e) {
//     e.preventDefault();
//     if (!canSubmit) return;
//     setSubmitting(true);

//     try {
//       const fd = new FormData();
//       fd.append("name", form.name);
//       fd.append("description", form.description || "");
//       fd.append("doc_date", form.doc_date);
//       fd.append("category", form.category);
//       fd.append("file", form.file);

//       const res = await axiosInstance.post("/documents/upload/file/", fd, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       console.log("سند ثبت شد:", res.data);

//       setOpen(false);
//       resetForm();
//       await fetchDocs(activeCategory);
//     } catch (err) {
//       console.error("خطا در ثبت سند", err.response?.data || err.message);
//       alert("خطا در ثبت سند");
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   return (
//     <div dir="rtl" className="p-4 max-w-7xl mx-auto mt-24">
//       {/* Header */}
//       <div className="flex items-center justify-between mb-4">
//         <h1 className="text-2xl font-bold text-gray-800">
//           نرم‌افزار بازرگانی &gt; بایگانی اسناد
//         </h1>
//         <button
//           onClick={() => {
//             setOpen(true);
//             setForm((f) => ({ ...f, category: activeCategory }));
//           }}
//           className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 shadow"
//         >
//           ثبت جدید
//           <svg
//             className="w-4 h-4"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//           >
//             <path d="M12 5v14M5 12h14" strokeWidth="2" strokeLinecap="round" />
//           </svg>
//         </button>
//       </div>

//       {/* 🔹 چهار دکمه جدید */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
//         <button
//           onClick={() => navigate("/invoices/new")}
//           className="px-4 py-3 bg-indigo-600 text-white rounded-xl font-semibold hover:bg-indigo-700"
//         >
//           ایجاد اینوویس/پکینگ/گواهی مبدا
//         </button>
//         <button
//           onClick={() => navigate("/invoices/list")}
//           className="px-4 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700"
//         >
//           لیست اینوویس/پکینگ/گواهی مبدا
//         </button>
//         <button
//           onClick={() => navigate("/proforma-invoices/new")}
//           className="px-4 py-3 bg-indigo-600 text-white rounded-xl font-semibold hover:bg-indigo-700"
//         >
//           ایجاد پروفورما
//         </button>
//         <button
//           onClick={() => navigate("/proforma-invoices/list")}
//           className="px-4 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700"
//         >
//           لیست پروفورما
//         </button>
//       </div>

//       {/* Explorer layout */}
//       <div className="bg-white rounded-xl shadow overflow-hidden border border-gray-100">
//         <div className="flex">
//           {/* Sidebar */}
//           <aside className="w-64 border-l md:border-l-0 md:border-r border-gray-100 bg-gray-50">
//             <div className="p-3 text-xs font-medium text-gray-500">
//               دسته‌بندی‌ها
//             </div>
//             <ul className="max-h-[70vh] overflow-auto">
//               {CATEGORIES.map((cat) => {
//                 const isActive = cat === activeCategory;
//                 return (
//                   <li key={cat}>
//                     <button
//                       onClick={() => setActiveCategory(cat)}
//                       className={`w-full text-right px-4 py-2 flex items-center gap-2 hover:bg-blue-50 ${
//                         isActive
//                           ? "bg-blue-100 text-blue-700 font-semibold"
//                           : "text-gray-700"
//                       }`}
//                     >
//                       <svg
//                         className="w-5 h-5 shrink-0"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                       >
//                         <path
//                           d="M3 7h5l2 2h11v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"
//                           strokeWidth="1.5"
//                         />
//                       </svg>
//                       <span className="truncate">{cat}</span>
//                     </button>
//                   </li>
//                 );
//               })}
//             </ul>
//           </aside>

//           {/* Main content */}
//           <main className="flex-1 p-4">
//             <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 mb-4">
//               <div className="text-sm text-gray-600">
//                 مسیر: <span className="text-gray-900 font-medium">بایگانی</span>
//                 {" / "}
//                 <span className="text-blue-700 font-medium">
//                   {activeCategory}
//                 </span>
//               </div>
//             </div>

//             {/* List/Grid */}
//             <div className="min-h-[50vh] border border-gray-100 rounded-lg">
//               {loading ? (
//                 <div className="p-8 text-center text-gray-500">
//                   در حال دریافت اسناد…
//                 </div>
//               ) : docs.length === 0 ? (
//                 <div className="p-8 text-center text-gray-500">
//                   سندی برای «{activeCategory}» ثبت نشده است.
//                 </div>
//               ) : (
//                 <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 p-3">
//                   {docs.map((d) => (
//                     <li
//                       key={d.id}
//                       className="border border-gray-200 rounded-lg p-3 hover:shadow-sm transition"
//                     >
//                       <div className="flex items-start justify-between gap-3">
//                         <div className="flex items-center gap-2">
//                           <svg
//                             className="w-6 h-6 text-gray-600"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                           >
//                             <path
//                               d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
//                               strokeWidth="1.5"
//                             />
//                             <path d="M14 3v6h6" strokeWidth="1.5" />
//                           </svg>
//                           <div>
//                             <div className="font-semibold text-gray-800 truncate max-w-[200px]">
//                               {d.name}
//                             </div>
//                             <div className="text-xs text-gray-500">
//                               {d.doc_date}{" "}
//                               {d.size
//                                 ? `• ${Math.round(d.size / 1024)} KB`
//                                 : ""}
//                             </div>
//                           </div>
//                         </div>
//                         {d.file ? (
//                           <a
//                             className="text-blue-600 text-sm hover:underline"
//                             href={d.file}
//                             target="_blank"
//                             rel="noreferrer"
//                           >
//                             دانلود
//                           </a>
//                         ) : null}
//                       </div>
//                       {d.description ? (
//                         <div className="mt-2 text-sm text-gray-600 line-clamp-2">
//                           {d.description}
//                         </div>
//                       ) : null}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           </main>
//         </div>
//       </div>

//       {/* Modal */}
//       {open && (
//         <div className="fixed inset-0 z-50">
//           <div
//             className="absolute inset-0 bg-black/30"
//             onClick={() => setOpen(false)}
//           />
//           <div className="absolute inset-0 flex items-center justify-center p-4">
//             <div className="w-full max-w-xl bg-white rounded-2xl shadow-xl border border-gray-100">
//               <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
//                 <h3 className="text-lg font-bold text-gray-800">
//                   ثبت سند جدید
//                 </h3>
//                 <button
//                   onClick={() => setOpen(false)}
//                   className="p-1 rounded hover:bg-gray-100"
//                 >
//                   <svg
//                     className="w-5 h-5"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                     fill="none"
//                   >
//                     <path d="M6 6l12 12M18 6L6 18" strokeWidth="2" />
//                   </svg>
//                 </button>
//               </div>

//               <form onSubmit={handleSubmit} className="px-5 py-4 space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">
//                     نام سند <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     required
//                     value={form.name}
//                     onChange={(e) =>
//                       setForm((f) => ({ ...f, name: e.target.value }))
//                     }
//                     className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
//                     placeholder="مثلاً: فاکتور 1203"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">
//                     توضیحات (اختیاری)
//                   </label>
//                   <textarea
//                     rows={3}
//                     value={form.description}
//                     onChange={(e) =>
//                       setForm((f) => ({ ...f, description: e.target.value }))
//                     }
//                     className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
//                     placeholder="توضیحات تکمیلی…"
//                   />
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       تاریخ سند <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="date"
//                       required
//                       value={form.doc_date}
//                       onChange={(e) =>
//                         setForm((f) => ({ ...f, doc_date: e.target.value }))
//                       }
//                       className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
//                     />
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700">
//                       دسته‌بندی سند <span className="text-red-500">*</span>
//                     </label>
//                     <select
//                       required
//                       value={form.category}
//                       onChange={(e) =>
//                         setForm((f) => ({ ...f, category: e.target.value }))
//                       }
//                       className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
//                     >
//                       {CATEGORIES.map((c) => (
//                         <option key={c} value={c}>
//                           {c}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700">
//                     آپلود فایل <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="file"
//                     required
//                     onChange={(e) =>
//                       setForm((f) => ({
//                         ...f,
//                         file: e.target.files?.[0] || null,
//                       }))
//                     }
//                     className="mt-1 w-full text-sm"
//                     accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
//                   />
//                   {form.file ? (
//                     <div className="mt-1 text-xs text-gray-500">
//                       فایل انتخاب‌شده: {form.file.name} (
//                       {Math.round(form.file.size / 1024)} KB)
//                     </div>
//                   ) : null}
//                 </div>

//                 <div className="pt-2 flex items-center justify-end gap-2">
//                   <button
//                     type="button"
//                     onClick={() => setOpen(false)}
//                     className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
//                   >
//                     انصراف
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={!canSubmit || submitting}
//                     className={`px-4 py-2 rounded-lg text-white font-semibold ${
//                       !canSubmit || submitting
//                         ? "bg-gray-400 cursor-not-allowed"
//                         : "bg-blue-600 hover:bg-blue-700"
//                     }`}
//                   >
//                     {submitting ? "در حال ثبت…" : "تأیید و ذخیره"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DocumentExplorer;



import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import { toast } from "react-hot-toast";

const documentErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  const labels = {
    name: "نام",
    doc_date: "تاریخ سند",
    sub_category_id: "زیر‌دسته‌بندی",
    category_id: "دسته‌بندی",
    file: "فایل",
  };
  if (data && typeof data === "object") {
    const details = Object.entries(data)
      .map(([field, value]) => {
        const text = Array.isArray(value) ? value.join("، ") : value;
        return typeof text === "string" ? `${labels[field] || field}: ${text}` : "";
      })
      .filter(Boolean);
    if (details.length) return details.join("؛ ");
  }
  return fallback;
};

const DocumentExplorer = () => {
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubCategory, setActiveSubCategory] = useState(null);
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categoriesError, setCategoriesError] = useState("");
  const [docsError, setDocsError] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [showSubCategoryDashboard, setShowSubCategoryDashboard] = useState(false);
  
  // Modal state for document upload
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: "",
    description: "",
    doc_date: "",
    sub_category_id: "",
    file: null,
  });
  const [submitting, setSubmitting] = useState(false);

  // Modal state for adding category
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");

  // Modal state for adding subcategory
  const [subCategoryModalOpen, setSubCategoryModalOpen] = useState(false);
  const [newSubCategoryName, setNewSubCategoryName] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const navigate = useNavigate();

  const canSubmit = useMemo(
    () => form.name.trim() && form.doc_date && form.sub_category_id && form.file,
    [form]
  );

  const canSubmitCategory = useMemo(
    () => newCategoryName.trim(),
    [newCategoryName]
  );

  const canSubmitSubCategory = useMemo(
    () => newSubCategoryName.trim() && selectedCategoryId,
    [newSubCategoryName, selectedCategoryId]
  );

  // Fetch categories
  const fetchCategories = useCallback(async () => {
    setCategoriesLoading(true);
    setCategoriesError("");
    try {
      const res = await axiosInstance.get("/documents/document-categories/");
      const data = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.results) ? res.data.results : [];
      setCategories(data);
      if (data.length > 0 && !activeCategory) {
        setActiveCategory(data[0].name);
      }
    } catch {
      setCategoriesError("دسته‌بندی‌های اسناد بارگذاری نشدند.");
    } finally {
      setCategoriesLoading(false);
    }
  }, [activeCategory]);

  // Fetch documents
  async function fetchDocs(category, subCategoryId = null) {
    setLoading(true);
    setDocsError("");
    try {
      const params = subCategoryId ? { sub_category_id: subCategoryId } : { category };
      const res = await axiosInstance.get("/documents/documents/", { params });
      setDocs(Array.isArray(res.data) ? res.data : res.data?.results || []);
    } catch {
      setDocsError("اسناد بارگذاری نشدند. دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  }

  // Add new category
  async function handleAddCategory(e) {
    e.preventDefault();
    if (!canSubmitCategory) return;
    setSubmitting(true);
    setSubmitError("");

    try {
      await axiosInstance.post(
        "/documents/document-categories/",
        { name: newCategoryName },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setCategoryModalOpen(false);
      setNewCategoryName("");
      await fetchCategories();
      toast.success("دسته‌بندی ثبت شد.");
    } catch (err) {
      setSubmitError(documentErrorMessage(err, "ثبت دسته‌بندی ناموفق بود."));
    } finally {
      setSubmitting(false);
    }
  }

  // Add new subcategory
  async function handleAddSubCategory(e) {
    e.preventDefault();
    if (!canSubmitSubCategory) return;
    setSubmitting(true);
    setSubmitError("");

    try {
      await axiosInstance.post(
        "/documents/document-subcategories/",
        { name: newSubCategoryName, category_id: selectedCategoryId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setSubCategoryModalOpen(false);
      setNewSubCategoryName("");
      setSelectedCategoryId("");
      await fetchCategories();
      toast.success("زیر‌دسته‌بندی ثبت شد.");
    } catch (err) {
      setSubmitError(documentErrorMessage(err, "ثبت زیر‌دسته‌بندی ناموفق بود."));
    } finally {
      setSubmitting(false);
    }
  }

  // Submit new document
  async function handleSubmit(e) {
    e.preventDefault();
    if (!canSubmit) return;
    setSubmitting(true);
    setSubmitError("");

    try {
      const fd = new FormData();
      fd.append("name", form.name);
      fd.append("description", form.description || "");
      fd.append("doc_date", form.doc_date);
      fd.append("sub_category_id", form.sub_category_id);
      fd.append("file", form.file);

      await axiosInstance.post("/documents/documents/", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setOpen(false);
      resetForm();
      await fetchDocs(activeCategory, activeSubCategory);
      toast.success("سند ثبت شد.");
    } catch (err) {
      setSubmitError(documentErrorMessage(err, "ثبت سند ناموفق بود."));
    } finally {
      setSubmitting(false);
    }
  }

  // Handle double-click on category
  const openSubcategories = () => {
    setShowSubCategoryDashboard(true);
    setActiveSubCategory(null);
    setDocs([]);
  };

  // Handle click on subcategory
  const handleSubCategoryClick = (subCategoryId) => {
    setActiveSubCategory(subCategoryId);
    setShowSubCategoryDashboard(false);
    fetchDocs(null, subCategoryId);
  };

  function resetForm() {
    setForm({
      name: "",
      description: "",
      doc_date: "",
      sub_category_id: "",
      file: null,
    });
  }

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  useEffect(() => {
    if (activeCategory && !showSubCategoryDashboard && !activeSubCategory) {
      fetchDocs(activeCategory);
    }
  }, [activeCategory, showSubCategoryDashboard, activeSubCategory]);

  // Get subcategories for the active category
  const filteredSubCategories = useMemo(() => {
    if (!activeCategory) return [];
    const selectedCategory = categories.find((cat) => cat.name === activeCategory);
    return selectedCategory?.subcategories || [];
  }, [activeCategory, categories]);

  return (
    <div dir="rtl" className="p-4 max-w-7xl mx-auto mt-24">
      {/* Header */}
<div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
  <h1 className="text-2xl font-bold text-gray-800">
    نرم‌افزار بازرگانی &gt; بایگانی اسناد
  </h1>
  <div className="flex flex-wrap gap-2">
    <button
      onClick={() => { setSubmitError(""); setCategoryModalOpen(true); }}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-100 text-blue-800 font-semibold hover:bg-blue-200 shadow-sm transition"
    >
      افزودن دسته‌بندی
    </button>
    <button
      onClick={() => { setSubmitError(""); setSubCategoryModalOpen(true); }}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-100 text-blue-800 font-semibold hover:bg-blue-200 shadow-sm transition"
    >
      افزودن زیر-دسته‌بندی
    </button>
    <button
      onClick={() => {
        setSubmitError("");
        setOpen(true);
        setForm((f) => ({ ...f, sub_category_id: "" }));
      }}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-100 text-blue-800 font-semibold hover:bg-blue-200 shadow-sm transition"
    >
      ثبت سند جدید
      <svg
        className="w-4 h-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path d="M12 5v14M5 12h14" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </button>
  </div>
</div>

{/* چهار دکمه اصلی */}
<div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
  <button
    onClick={() => navigate("/invoices/new")}
    className="px-4 py-3 bg-blue-100 text-blue-800 rounded-xl font-semibold hover:bg-blue-200 transition shadow-sm"
  >
    ایجاد اینوویس/پکینگ/گواهی مبدا
  </button>
  <button
    onClick={() => navigate("/invoices/list")}
    className="px-4 py-3 bg-blue-100 text-blue-800 rounded-xl font-semibold hover:bg-blue-200 transition shadow-sm"
  >
    لیست اینوویس/پکینگ/گواهی مبدا
  </button>
  <button
    onClick={() => navigate("/proforma-invoices/new")}
    className="px-4 py-3 bg-blue-100 text-blue-800 rounded-xl font-semibold hover:bg-blue-200 transition shadow-sm"
  >
    ایجاد پروفورما
  </button>
  <button
    onClick={() => navigate("/proforma-invoices/list")}
    className="px-4 py-3 bg-blue-100 text-blue-800 rounded-xl font-semibold hover:bg-blue-200 transition shadow-sm"
  >
    لیست پروفورما
  </button>
</div>

      {/* Explorer layout */}
      <div className="bg-white rounded-xl shadow overflow-hidden border border-gray-100">
        <div className="flex flex-col md:flex-row">
          {/* Sidebar */}
          <aside className="w-full border-b border-gray-100 bg-gray-50 md:w-64 md:shrink-0 md:border-b-0 md:border-l">
            <div className="p-3 text-xs font-medium text-gray-500">
              دسته‌بندی‌ها
            </div>
            <ul className="max-h-56 overflow-auto md:max-h-[70vh]">
              {categoriesLoading ? (
                <li role="status" className="px-4 py-3 text-sm text-gray-500">در حال بارگذاری دسته‌بندی‌ها...</li>
              ) : categoriesError ? (
                <li role="alert" className="px-4 py-3 text-sm text-rose-700">
                  <p>{categoriesError}</p>
                  <button type="button" onClick={fetchCategories} className="mt-2 font-semibold underline">تلاش دوباره</button>
                </li>
              ) : Array.isArray(categories) && categories.length > 0 ? (
                categories.map((cat) => {
                  const isActive = cat.name === activeCategory;
                  return (
                    <li key={cat.id} className="flex items-center">
                      <button
                        onClick={() => {
                          setActiveCategory(cat.name);
                          setShowSubCategoryDashboard(false);
                          setActiveSubCategory(null);
                        }}
                        onDoubleClick={openSubcategories}
                        className={`min-w-0 flex-1 text-right px-4 py-2 flex items-center gap-2 hover:bg-blue-50 ${
                          isActive ? "bg-blue-100 text-blue-700 font-semibold" : "text-gray-700"
                        }`}
                      >
                        <svg
                          className="w-5 h-5 shrink-0"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            d="M3 7h5l2 2h11v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"
                            strokeWidth="1.5"
                          />
                        </svg>
                        <span className="truncate">{cat.name}</span>
                      </button>
                      {cat.subcategories?.length > 0 && (
                        <button type="button" className="shrink-0 px-2 py-2 text-xs text-blue-700 hover:underline"
                          aria-label={`نمایش زیر‌دسته‌های ${cat.name}`}
                          onClick={() => { setActiveCategory(cat.name); openSubcategories(); }}>
                          زیر‌دسته‌ها
                        </button>
                      )}
                    </li>
                  );
                })
              ) : (
                <li className="px-4 py-2 text-gray-500">
                  هیچ دسته‌بندی یافت نشد
                </li>
              )}
            </ul>
          </aside>

          {/* Main content */}
          <main className="min-w-0 flex-1 p-4">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 mb-4">
              <div className="text-sm text-gray-600">
                مسیر: <span className="text-gray-900 font-medium">بایگانی</span>
                {" / "}
                <span className="text-blue-700 font-medium">
                  {activeCategory || "هیچ دسته‌بندی انتخاب نشده"}
                  {activeSubCategory
                    ? ` / ${
                        filteredSubCategories.find((sub) => sub.id === activeSubCategory)
                          ?.name || "زیر-دسته‌بندی"
                      }`
                    : ""}
                </span>
              </div>
            </div>

            {/* Subcategory Dashboard or Document List */}
            <div className="min-h-[50vh] border border-gray-100 rounded-lg">
              {loading ? (
                <div role="status" className="p-8 text-center text-gray-500">
                  در حال دریافت داده‌ها…
                </div>
              ) : docsError && !showSubCategoryDashboard ? (
                <div role="alert" className="p-8 text-center text-rose-700">
                  <p>{docsError}</p>
                  <button type="button" onClick={() => fetchDocs(activeCategory, activeSubCategory)} className="mt-3 rounded-lg bg-rose-700 px-4 py-2 text-sm text-white">
                    تلاش دوباره
                  </button>
                </div>
              ) : showSubCategoryDashboard ? (
                filteredSubCategories.length === 0 ? (
                  <div className="p-8 text-center text-gray-500">
                    هیچ زیر-دسته‌بندی برای «{activeCategory}» یافت نشد.
                  </div>
                ) : (
                  <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 p-3">
                    {filteredSubCategories.map((sub) => (
                      <li key={sub.id}>
                        <button type="button" onClick={() => handleSubCategoryClick(sub.id)}
                          className="w-full rounded-lg border border-gray-200 bg-gray-50 p-3 text-right transition hover:shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500">
                        <div className="flex items-center gap-2">
                          <svg
                            className="w-6 h-6 text-gray-600"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                          >
                            <path
                              d="M3 7h5l2 2h11v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"
                              strokeWidth="1.5"
                            />
                          </svg>
                          <div>
                            <div className="font-semibold text-gray-800 truncate max-w-[200px]">
                              {sub.name}
                            </div>
                            <div className="text-xs text-gray-500">
                              دسته‌بندی: {activeCategory}
                            </div>
                          </div>
                        </div>
                        </button>
                      </li>
                    ))}
                  </ul>
                )
              ) : docs.length === 0 ? (
                <div className="p-8 text-center text-gray-500">
                  سندی برای «
                  {activeSubCategory
                    ? filteredSubCategories.find((sub) => sub.id === activeSubCategory)
                        ?.name || "زیر-دسته‌بندی"
                    : activeCategory || "دسته‌بندی"}
                  » ثبت نشده است.
                </div>
              ) : (
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 p-3">
                  {docs.map((d) => (
                    <li
                      key={d.id}
                      className="border border-gray-200 rounded-lg p-3 hover:shadow-sm transition"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex items-center gap-2">
                          <svg
                            className="w-6 h-6 text-gray-600"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                          >
                            <path
                              d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                              strokeWidth="1.5"
                            />
                            <path d="M14 3v6h6" strokeWidth="1.5" />
                          </svg>
                          <div>
                            <div className="font-semibold text-gray-800 truncate max-w-[200px]">
                              {d.name}
                            </div>
                            <div className="text-xs text-gray-500">
                              {d.doc_date}{" "}
                              {d.size
                                ? `• ${Math.round(d.size / 1024)} KB`
                                : ""}
                            </div>
                          </div>
                        </div>
                        {d.file ? (
                          <a
                            className="text-blue-600 text-sm hover:underline"
                            href={d.file}
                            target="_blank"
                            rel="noreferrer"
                          >
                            دانلود
                          </a>
                        ) : null}
                      </div>
                      {d.description ? (
                        <div className="mt-2 text-sm text-gray-600 line-clamp-2">
                          {d.description}
                        </div>
                      ) : null}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </main>
        </div>
      </div>

      {/* Document Upload Modal */}
      {open && (
        <div className="fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/30"
            onClick={() => setOpen(false)}
          />
          <div className="absolute inset-0 flex items-center justify-center p-4">
            <div className="max-h-[calc(100vh-2rem)] w-full max-w-xl overflow-y-auto rounded-2xl border border-gray-100 bg-white shadow-xl">
              <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-800">
                  ثبت سند جدید
                </h3>
                <button
                  onClick={() => setOpen(false)}
                  className="p-1 rounded hover:bg-gray-100"
                >
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    fill="none"
                  >
                    <path d="M6 6l12 12M18 6L6 18" strokeWidth="2" />
                  </svg>
                </button>
              </div>

              <form onSubmit={handleSubmit} className="px-5 py-4 space-y-4">
                {submitError && <p role="alert" className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">{submitError}</p>}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    نام سند <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    value={form.name}
                    onChange={(e) =>
                      setForm((f) => ({ ...f, name: e.target.value }))
                    }
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                    placeholder="مثلاً: قرارداد فروش 1404"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    توضیحات (اختیاری)
                  </label>
                  <textarea
                    rows={3}
                    value={form.description}
                    onChange={(e) =>
                      setForm((f) => ({ ...f, description: e.target.value }))
                    }
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                    placeholder="توضیحات تکمیلی…"
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      تاریخ سند <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      required
                      value={form.doc_date}
                      onChange={(e) =>
                        setForm((f) => ({ ...f, doc_date: e.target.value }))
                      }
                      className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      زیر-دسته‌بندی سند <span className="text-red-500">*</span>
                    </label>
                    <select
                      required
                      value={form.sub_category_id}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          sub_category_id: e.target.value,
                        }))
                      }
                      className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                    >
                      <option value="">انتخاب زیر-دسته‌بندی</option>
                      {Array.isArray(categories) &&
                        categories.flatMap((cat) =>
                          cat.subcategories.map((sub) => (
                            <option key={sub.id} value={sub.id}>
                              {sub.name} (دسته‌بندی: {cat.name})
                            </option>
                          ))
                        )}
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    آپلود فایل <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="file"
                    required
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        file: e.target.files?.[0] || null,
                      }))
                    }
                    className="mt-1 w-full text-sm"
                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                  />
                  {form.file ? (
                    <div className="mt-1 text-xs text-gray-500">
                      فایل انتخاب‌شده: {form.file.name} (
                      {Math.round(form.file.size / 1024)} KB)
                    </div>
                  ) : null}
                </div>

                <div className="pt-2 flex items-center justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                  >
                    انصراف
                  </button>
                  <button
                    type="submit"
                    disabled={!canSubmit || submitting}
                    className={`px-4 py-2 rounded-lg text-white font-semibold ${
                      !canSubmit || submitting
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    {submitting ? "در حال ثبت…" : "تأیید و ذخیره"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Add Category Modal */}
      {categoryModalOpen && (
        <div className="fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/30"
            onClick={() => setCategoryModalOpen(false)}
          />
          <div className="absolute inset-0 flex items-center justify-center p-4">
            <div className="max-h-[calc(100vh-2rem)] w-full max-w-md overflow-y-auto rounded-2xl border border-gray-100 bg-white shadow-xl">
              <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-800">
                  افزودن دسته‌بندی جدید
                </h3>
                <button
                  onClick={() => setCategoryModalOpen(false)}
                  className="p-1 rounded hover:bg-gray-100"
                >
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    fill="none"
                  >
                    <path d="M6 6l12 12M18 6L6 18" strokeWidth="2" />
                  </svg>
                </button>
              </div>

              <form onSubmit={handleAddCategory} className="px-5 py-4 space-y-4">
                {submitError && <p role="alert" className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">{submitError}</p>}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    نام دسته‌بندی <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    value={newCategoryName}
                    onChange={(e) => setNewCategoryName(e.target.value)}
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                    placeholder="مثلاً: قراردادها"
                  />
                </div>

                <div className="pt-2 flex items-center justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => setCategoryModalOpen(false)}
                    className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                  >
                    انصراف
                  </button>
                  <button
                    type="submit"
                    disabled={!canSubmitCategory || submitting}
                    className={`px-4 py-2 rounded-lg text-white font-semibold ${
                      !canSubmitCategory || submitting
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-600 hover:bg-green-700"
                    }`}
                  >
                    {submitting ? "در حال ثبت…" : "تأیید و ذخیره"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Add SubCategory Modal */}
      {subCategoryModalOpen && (
        <div className="fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/30"
            onClick={() => setSubCategoryModalOpen(false)}
          />
          <div className="absolute inset-0 flex items-center justify-center p-4">
            <div className="max-h-[calc(100vh-2rem)] w-full max-w-md overflow-y-auto rounded-2xl border border-gray-100 bg-white shadow-xl">
              <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-800">
                  افزودن زیر-دسته‌بندی جدید
                </h3>
                <button
                  onClick={() => setSubCategoryModalOpen(false)}
                  className="p-1 rounded hover:bg-gray-100"
                >
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    fill="none"
                  >
                    <path d="M6 6l12 12M18 6L6 18" strokeWidth="2" />
                  </svg>
                </button>
              </div>

              <form
                onSubmit={handleAddSubCategory}
                className="px-5 py-4 space-y-4"
              >
                {submitError && <p role="alert" className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">{submitError}</p>}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    نام زیر-دسته‌بندی <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    value={newSubCategoryName}
                    onChange={(e) => setNewSubCategoryName(e.target.value)}
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                    placeholder="مثلاً: قرارداد فروش"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    دسته‌بندی <span className="text-red-500">*</span>
                  </label>
                  <select
                    required
                    value={selectedCategoryId}
                    onChange={(e) => setSelectedCategoryId(e.target.value)}
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                  >
                    <option value="">انتخاب دسته‌بندی</option>
                    {Array.isArray(categories) &&
                      categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="pt-2 flex items-center justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => setSubCategoryModalOpen(false)}
                    className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                  >
                    انصراف
                  </button>
                  <button
                    type="submit"
                    disabled={!canSubmitSubCategory || submitting}
                    className={`px-4 py-2 rounded-lg text-white font-semibold ${
                      !canSubmitSubCategory || submitting
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-purple-600 hover:bg-purple-700"
                    }`}
                  >
                    {submitting ? "در حال ثبت…" : "تأیید و ذخیره"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentExplorer;
